<template>
  <div class="center">
    <AppBtn primary v-bind="$attrs" prepend-icon="mdi:lock" class="btn" size="x-large">
      <span>
        {{ $tt('pay') }} <PriceSpan :price />
      </span>
    </AppBtn>
  </div>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

defineProps<{
  price: number;
}>();
</script>

<style scoped lang="scss">
.center {
  text-align: center;
}
.btn {
  width: 80%;
  font-size: 20px;
  box-shadow: 3px 10px 20px 0px rgba(35, 210, 163, 0.3);
  color: #fff;
  margin-block: var(--space-5) var(--space-6);
  cursor: pointer;

  @media (max-width: 850px) {
    margin-top: var(--space-7);
    width: unset;
  }
}
</style>